import React from 'react';
import {
    AutoComplete,
    Button,
    DatePicker,
    Form,
    Input,
    InputNumber,
    Modal,
    notification,
    Select,
    Typography
} from "antd";
import ApiService from "../../../services/ApiService";
import moment from "moment";
import "moment/locale/fr";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

const { Search } = Input;
const { Text } = Typography;
const { Option } = Select;
moment.locale("fr");

export default class ModalAddField extends React.Component {

    constructor(props) {
        super(props);
        props.getRef(this);
    }

    initialState = {
        visible: false,
        loading: false,
        type: "TEXT",
        id: null,
        fields: [],
        fieldsValues: [],
        values: [],
        text: "",
    };

    state = this.initialState;

    async show(id) {
        await this.init();
        this.setState({ visible: true, id: id });
    }

    async init() {
        var res = await ApiService.get("/contact/fields");
        if (res.success) {
            this.setState({ fields: res.items, fieldsValues: res.values });
        }
    }

    close() {
        this.setState(this.initialState);
    }

    async onSubmit(data) {
        data.type = this.state.type;

        if (data.type === "NUMBER") {
            data.value = data.value.toString().replace(",", ".");
            data.value = data.value.includes(".") ? parseFloat(data.value) : parseInt(data.value);
        }

        if (data.type === "DATE" || data.type === "DATETIME") {
            data.value = data.value.toDate();
            if (data.type === "DATE") {
                data.value.setHours(0, 0, 0, 0);
            }
        }

        this.setState({ loading: true });

        var res = await ApiService.post("/contact/field/add/" + this.state.id, data);

        if (res.success) {
            notification.success({
                message: this.state.edit ? t`Succès de la modification` : t`Succès de l'ajout`
            });
            this.close();
            if (this.props.onFinish) {
                this.props.onFinish();
            }
        } else {
            notification.error({
                message: this.state.edit ? t`Erreur lors de la modification` : t`Erreur lors de l'ajout`
            });
        }

        this.setState({ loading: false });
    }

    formatFieldKey(key) {
        return key.normalize("NFD").replace(/[\u0300-\u036f]/g, "").trimStart().replace("  ", " ").toLowerCase();
    }

    formatType(type) {
        switch (type) {
            case "TEXT":
                return t`Texte`;
            case "NUMBER":
                return t`Nombre`;
            case "BOOL":
                return t`Oui/Non`;
            case "DATE":
                return t`Date`;
            case "DATETIME":
                return t`Date & Heure`;
            default:
                return null;
        }
    }

    render() {
        return (
            <Modal
                width="100%"
                title={t`Ajouter une information`}
                open={this.state.visible}
                destroyOnClose
                closable
                footer={null}
                onCancel={() => this.close()}
            >
                <Form
                    onFinish={(data) => this.onSubmit(data)}
                    ref={(ref) => this.form = ref}
                    layout={"vertical"}
                >
                    <Form.Item
                        label={<Trans>Nom</Trans>}
                        name="key"
                        rules={[{ required: true, message: t`Ce champ est obligatoire` }]}
                    >
                        <AutoComplete
                            options={this.state.fields.map((f) => ({
                                field: f,
                                value: f.key,
                                label: `${f.key} (${this.formatType(f.type)})`
                            }))}
                            filterOption={(inputValue, option) =>
                                option.field.key.toLowerCase().includes(this.formatFieldKey(inputValue))
                            }
                            onSelect={(value, option) => {
                                const values = this.state.fieldsValues.find(
                                    i => i.key === option.field.key && i.type === option.field.type
                                )?.values || [];
                                this.setState({ type: option.field.type, values: values });
                            }}
                            placeholder={t`Créer un nouveau ou choisissez un champ existant`}
                        />
                    </Form.Item>

                    <Form.Item label={<Trans>Type de champ</Trans>}>
                        <Select
                            value={this.state.type}
                            onChange={(v) => this.setState({ type: v })}
                        >
                            <Option value="TEXT"><Trans>Texte</Trans></Option>
                            <Option value="NUMBER"><Trans>Nombre</Trans></Option>
                            <Option value="BOOL"><Trans>Oui / Non</Trans></Option>
                            <Option value="DATE"><Trans>Date</Trans></Option>
                            <Option value="DATETIME"><Trans>Date & Heure</Trans></Option>
                        </Select>
                    </Form.Item>

                    {this.state.type === "TEXT" && (
                        <Form.Item
                            label={<Trans>Information textuelle</Trans>}
                            name="value"
                            rules={[{ required: true, message: t`Ce champ est obligatoire` }]}
                        >
                            <AutoComplete
                                options={this.state.values.map(v => ({
                                    label: v,
                                    value: v
                                }))}
                                placeholder={t`Sélectionnez ou donnez une nouvelle valeur`}
                            />
                        </Form.Item>
                    )}

                    {this.state.type === "NUMBER" && (
                        <Form.Item
                            label={<Trans>Nombre</Trans>}
                            name="value"
                            rules={[{ required: true, message: t`Ce champ est obligatoire` }]}
                        >
                            <InputNumber decimalSeparator="," placeholder={t`5 | 3.10 ...`} />
                        </Form.Item>
                    )}

                    {this.state.type === "BOOL" && (
                        <Form.Item
                            label={<Trans>Oui / Non ?</Trans>}
                            name="value"
                            rules={[{ required: true, message: t`Ce champ est obligatoire` }]}
                        >
                            <Select placeholder={t`Oui / Non`}>
                                <Option value="Oui"><Trans>Oui</Trans></Option>
                                <Option value="Non"><Trans>Non</Trans></Option>
                            </Select>
                        </Form.Item>
                    )}

                    {this.state.type === "DATE" && (
                        <Form.Item
                            label={<Trans>Date</Trans>}
                            name="value"
                            rules={[{ required: true, message: t`Ce champ est obligatoire` }]}
                        >
                            <DatePicker format="DD/MM/YYYY" />
                        </Form.Item>
                    )}

                    {this.state.type === "DATETIME" && (
                        <Form.Item
                            label={<Trans>Date & Heure</Trans>}
                            name="value"
                            rules={[{ required: true, message: t`Ce champ est obligatoire` }]}
                        >
                            <DatePicker showTime format="DD/MM/YYYY HH:mm" />
                        </Form.Item>
                    )}

                    <Form.Item style={{ display: "flex", justifyContent: "flex-end" }}>
                        <Button type="primary" htmlType="submit" loading={this.state.loading}>
                            <Trans>Valider</Trans>
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
}
